import styles from "./PolicyPage.module.css";

export default function TermsAndConditions() {
  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <p className={styles.eyebrow}>Legal</p>
        <h1 className={styles.title}>Terms & Conditions</h1>
        <p className={styles.updated}>Last updated: February 2025</p>
        <div className={styles.divider} />

        <div className={styles.section}>
          <h2>1. Acceptance of Terms</h2>
          <p>By accessing and using the Ratnapura Gems website (ratnapuragems.lk) or making a purchase, you agree to be bound by these Terms and Conditions. If you do not agree, please do not use our website or services.</p>
        </div>

        <div className={styles.section}>
          <h2>2. Products & Pricing</h2>
          <p>All products listed on our website are subject to availability. Prices are displayed in Sri Lankan Rupees (LKR) and are subject to change without prior notice. We reserve the right to refuse or cancel any order at our discretion.</p>
        </div>

        <div className={styles.section}>
          <h2>3. Orders & Payments</h2>
          <p>Orders are confirmed only upon receipt of payment or an agreed advance payment. We accept payments via the methods listed on our website and through our authorised payment partners.</p>
          <ul>
            <li>Advance payments are strictly non-refundable unless a manufacturing fault is confirmed on our part</li>
            <li>Full payment must be completed before delivery is arranged</li>
            <li>Ratnapura Gems reserves the right to cancel any order and issue a refund if we are unable to fulfil it</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2>4. Custom Orders</h2>
          <p>Custom jewellery orders require an advance payment to begin production. Once production has commenced, the advance payment is non-refundable. Customers are responsible for providing accurate specifications at the time of order. Changes requested after production has begun may incur additional charges.</p>
        </div>

        <div className={styles.section}>
          <h2>5. Delivery</h2>
          <p>We offer free island-wide delivery within Sri Lanka. Delivery timelines are estimates and may vary. Ratnapura Gems is not liable for delays caused by third-party courier services or circumstances beyond our control.</p>
        </div>

        <div className={styles.section}>
          <h2>6. Authenticity & Certification</h2>
<p>
  All gemstones sold by Ratnapura Gems are authentic and certified by a reputed gem testing laboratory in Sri Lanka. Certificates are provided with eligible purchases as specified at the time of sale.
</p>        
</div>

        <div className={styles.section}>
          <h2>7. Limitation of Liability</h2>
          <p>Ratnapura Gems shall not be liable for any indirect, incidental, or consequential damages arising from the use of our products or services. Our liability is limited to the value of the product purchased.</p>
        </div>

        <div className={styles.section}>
          <h2>8. Intellectual Property</h2>
          <p>All content on this website including images, videos, text, and logos are the property of Ratnapura Gems and may not be reproduced or used without written permission.</p>
        </div>

        <div className={styles.section}>
          <h2>9. Governing Law</h2>
          <p>These Terms and Conditions are governed by the laws of Sri Lanka. Any disputes shall be subject to the exclusive jurisdiction of the courts of Sri Lanka.</p>
        </div>

        <div className={styles.section}>
          <h2>10. Contact Us</h2>
          <p>For any questions regarding these Terms and Conditions, please contact us:</p>
          <p>WhatsApp: <a href="https://wa.me/94765851400">+94 76 585 1400</a></p>
          <p>Instagram: <a href="https://instagram.com/ratnapuragems" target="_blank" rel="noreferrer">@ratnapuragems</a></p>
        </div>

        <a href="/" className={styles.backBtn}>← Back to Home</a>
      </div>
    </div>
  );
}